<template>
    <vue-card>
        <div class="panel">
            <div class="head">
                <span class="title">查看名片统计</span>
            </div>
            <div class="search-wrapper">
                <div class="search-wrapper-left">
                    <form @keyup.13="search">
                        <Row :gutter="16" class-name="row-margin-bottom">
                            <Col span="4">
                                <Input v-model="searchData.keyWord" placeholder="编号/标题/IP" clearable></Input>
                            </Col>
                            <Col span="4">
                                <Select v-model="searchData.item_type" placeholder="名片类型" clearable :disabled="banType">
                                    <Option value="0">全部</Option>
                                    <Option value="1">项目</Option>
<!--                                    <Option value="2">载体</Option>-->
                                    <Option value="3">企业</Option>
                                </Select>
                            </Col>
                            <Col span="4">
                                <Select v-model="searchData.client" placeholder="客户端" clearable>
                                    <Option value="0">全部</Option>
                                    <Option value="2">手机端</Option>
                                    <Option value="1">电脑端</Option>
                                </Select>
                            </Col>
                            <Col span="4">
                                <DatePicker @on-change="changeAddTime" :value="addTime" type="daterange" confirm placement="bottom-end" placeholder="查看时间" style="width:100%" :editable="false"></DatePicker>
                            </Col>
                            <Col span="4">
                                <DatePicker @on-change="changeCloudTime" :value="cloudTime" type="daterange" confirm placement="bottom-end" placeholder="备注时间" style="width:100%" :editable="false"></DatePicker>
                            </Col>
                            <Col span="4">
                                <DatePicker @on-change="changeOverdue" :value="overdue" type="daterange" confirm placement="bottom-end" placeholder="过期时间" style="width:100%" :editable="false"></DatePicker>
                            </Col>
                        </Row>
                        <Row :gutter="16" v-if="searchData.type===2">
                            <group-user-select
                                    @refreshData="refreshSelectData"
                                    :all="false"
                                    :clearable="true"
                                    :group-id="searchData.company_group_id"
                                    :uid="searchData.uid"
                                    :span="'4'"
                                    :tip="['查看部门','查看人']"
                            >
                            </group-user-select>
                        </Row>
                    </form>
                </div>
                <div class="search-wrapper-right">
                    <Row class-name="row-margin-bottom">
                        <Col span="24" style="text-align:center">
                            <Button @click="search" class="search-button" type="primary">搜索</Button>
                        </Col>
                    </Row>
                </div>
            </div>
            <vue-table :loading="loadingStatus">
                <tr slot="thead">
                    <th width="5%">编号</th>
                    <th width="20%">标题</th>
                    <th width="15%">IP</th>
                    <th width="5%">类型</th>
                    <th width="5%">客户端</th>
                    <th v-if="searchData.type === 2" width="6%">查看人</th>
                    <th width="10%" class="tr-sort">
                        <label class="th-sort" @click="handleSort('addTimeSort')">
                            查看时间
                            <i v-if="searchData.addTimeSort=='asc'" class="fa fa-sort-asc"></i>
                            <i v-else-if="searchData.addTimeSort=='desc'" class="fa fa-sort-desc"></i>
                            <i v-else class="fa fa-sort"></i>
                        </label>
                    </th>
                    <th width="10%" class="tr-sort">
                        <label class="th-sort" @click="handleSort('cloudTimeSort')">
                            备注时间
                            <i v-if="searchData.cloudTimeSort=='asc'" class="fa fa-sort-asc" ></i>
                            <i v-else-if="searchData.cloudTimeSort=='desc'" class="fa fa-sort-desc" ></i>
                            <i v-else class="fa fa-sort"></i>
                        </label>
                    </th>
                    <th width="10%" class="tr-sort">
                        <label class="th-sort" @click="handleSort('overdueSort')">
                            过期时间
                            <i v-if="searchData.overdueSort=='asc'" class="fa fa-sort-asc"></i>
                            <i v-else-if="searchData.overdueSort=='desc'" class="fa fa-sort-desc"></i>
                            <i v-else class="fa fa-sort"></i>
                        </label>
                    </th>
                </tr>
                <tr slot="tbody" v-for="(log, index) in cardStatistics" class="card-tr">
                    <td>{{log.id}}</td>
                    <td>
                        <router-link :to="getJumpUrl(log)" :title="log.title" class="two-text">
                            {{log.title}}
                        </router-link>
                    </td>
                    <td><p class="two-text">{{log.ip}}</p></td>
                    <td>{{log.typeStr}}</td>
                    <td>{{log.client}}</td>
                    <td v-if="searchData.type === 2"><p class="two-text">{{log.username}}</p></td>
                    <td>{{log.addTime}}</td>
                    <td>{{log.cloudTime}}</td>
                    <td>{{log.overdue}}</td>
                </tr>
            </vue-table>
            <div class="list-bottom">
                <div class="page">
                    <Page :current="searchData.page" :total="rowCount" :placement="'top'" :page-size="searchData.pageSize" @on-page-size-change="changePageSize" @on-change="changePage" show-elevator show-sizer show-total></Page>
                </div>
            </div>
        </div>
    </vue-card>
</template>
<script>
import $api from "@/service/index";
import VueCard from '@/components/card/Card.vue'
import VueTable from "@/components/table/Table.vue";
import GroupUserSelect from "@/components/groupUserSelect/GroupUserSelect";
import utils from '@/utils';
import Cookies from 'js-cookie';

export default {
    components:{
        VueCard,
        VueTable,
        GroupUserSelect
    },
    data() {
        return {
            searchData: {
                page: 1,
                pageSize:10,
            },
            rowCount: 0,
            cardStatistics: [],
            addTime: [],
            cloudTime: [],
            overdue: [],
            loadingStatus : true,
            banType : false,
        } 
    },
    watch: {
        '$route': function(to,from){
            if(Object.keys(to.query).length <=0){
                this.searchData = {
                    page: 1,
                    pageSize:10,
                };
            }
            this.initTableData();
        }
    },
    methods: {
        /**
         * 返回标题跳转url
         * @param {Object} data 相关数据
         */
        getJumpUrl(data){
            let url = ''
            if(data.type == 1){
                url = `/land/land-item-all/detail/${data.itemid}`;
            }else if(data.type == 3){
                url = `/enterprise/enterprise-all/enterprise-all-detail/${data.itemid}`;
            }else{
                url = '';
            }
            return url;
        },
        //判断是单位还是个人
        getType(){
            let routerName = this.$route.name;
            if(routerName === "company-card-record"){
                //单位
                this.searchData.type = 2;
                let uid = Cookies.get("uid");
                let commonInfo = JSON.parse( localStorage.getItem(`_tanikawa_user_${uid}_commoninfo`) );
                this.searchData.company_id = commonInfo.userinfo.company_id;
                //判断是否为从名片组件跳转过来的
                this.banType = false;
                if(this.$route.params.itemId) {
                    this.searchData.itemId = this.$route.params.itemId;
                    this.searchData.item_type = this.$route.params.type;
                    this.banType = true;
                }
            }else{
                //个人
                this.searchData.type = 1;
                this.searchData.uid = this.getUid();
            }
        },
        //获取uid
        getUid(){
            if(this.$route.params.uid){
                return this.$route.params.uid;
            }else{
                return Cookies.get('uid');
            }
        },
        //获取列表数据
        initTableData(){
            this.getType();
            let _self = this;
            this.loadingStatus = true;
            $api.getCardStatistics(_self.searchData).then( response => {
                _self.loadingStatus = false;
                _self.cardStatistics = response.data;
                _self.rowCount = parseInt(response.count);
            });
        },
        /**
         * 部门和人联动搜索框change触发
         * @param {object} data 部门和uid
         */
        refreshSelectData(data){
            this.searchData.company_group_id = data.groupId;
            this.searchData.uid = data.uid;
        },
        /**
         * 改变每页显示的数量
         * 
         * @param  {Number} pageSize  每页显示的数量
         */
        changePageSize(pageSize) {
            this.searchData.pageSize = pageSize;
            this.changeRoute();
        },
        /**
         * 改变当前页
         *
         * @param  {Number} page  当前页
         */
        changePage(page) {
            this.searchData.page = page;
            this.changeRoute();
        },
        //搜素
        search(){
            this.searchData.page = 1;
            this.changeRoute();
        },
        /**
         * 处理日期
         * @param {array} dateArr 日期数组
         */
        changeAddTime(dateArr){
            this.searchData.addTime1 = dateArr[0];
            this.searchData.addTime2 = dateArr[1];
        },
        /**
         * 处理日期
         * @param {array} dateArr 日期数组
         */
        changeCloudTime(dateArr){
            this.searchData.cloudTime1 = dateArr[0];
            this.searchData.cloudTime2 = dateArr[1];
        },
        /**
         * 处理日期
         * @param {array} dateArr 日期数组
         */
        changeOverdue(dateArr){
            this.searchData.overdue1 = dateArr[0];
            this.searchData.overdue2 = dateArr[1];
        },
        //条件放路由里
        changeRoute(){
            let searchData = this.searchData;  
            let submitData = {};
            utils.filterSearchData(searchData, submitData);
            this.searchData = submitData;
            this.$router.push({
                path: this.$route.path,
                query: this.searchData
            });
        },
        /**
         * 排序
         * @param {string} field 字段
         */
        handleSort(field){
            let oldSort = this.searchData[field];
            this.searchData.addTimeSort = '';
            this.searchData.cloudTimeSort = '';
            this.searchData.overdueSort = '';
            this.searchData[field] = oldSort;
            // if(this.searchData[field] != 'asc'){
            //     this.searchData[field] = 'asc';
            // }else{
            //     this.searchData[field] = 'desc';
            // }
            if(this.searchData[field] === "asc"){
                this.searchData[field] = "desc";
            }else if(this.searchData[field] === "desc"){
                this.searchData[field] = "";
            }else{
                this.searchData[field] = "asc";
            }
            this.changeRoute();
        },
        /**
         * 初始化页面
         */
        initSearch() {
            this.searchData = Object.assign({}, this.$route.query);
            //分页
            if(this.searchData.hasOwnProperty('page')){
                this.searchData.page = parseInt(this.searchData.page);
            }else{
                this.searchData.page = 1;
            }
            if(this.searchData.hasOwnProperty('pageSize')){
                this.searchData.pageSize = parseInt(this.searchData.pageSize);
            }else{
                this.searchData.pageSize = 10;
            }
            if(!this.searchData.hasOwnProperty('type')){
                this.searchData.type = 1;
            }
            //时间
            this.addTime = [this.searchData.addTime1, this.searchData.addTime2];
            this.cloudTime = [this.searchData.cloudTime1, this.searchData.cloudTime2];
            this.overdue = [this.searchData.overdue1, this.searchData.overdue2];
        },
    },
    mounted() {
        this.initSearch();
        this.initTableData();
    }
};
</script>


<style scoped>
    @import './list.less';
</style>


// WEBPACK FOOTER //
// src/pages/usercenter/businessCards/List.vue